import { render, staticRenderFns } from "./poi-map.vue?vue&type=template&id=7c5bf70c&"
import script from "./poi-map.vue?vue&type=script&lang=ts&"
export * from "./poi-map.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports